import {DataManager} from './DataManager';
import {FirstLoginPage} from "./FirstLoginPage.ts";
import {CalendarPage} from './CalendarPage';
import {PublicPage} from './PublicPage';
import {setupErrorHandler} from "./utils.ts";

setupErrorHandler();

document.addEventListener('DOMContentLoaded', async () => {

    // Initialize components
    const dataManager = new DataManager();
    if (renderPublicPage(dataManager)) {
        return
    }

    // Normal flow for authenticated users
    const firstLoginPage = new FirstLoginPage(submitFirstLogin, handleLogin);
    firstLoginPage.setupHandlers()
    const calendarPageInstance = new CalendarPage(dataManager);
    calendarPageInstance.setupHandlers();

    dataManager.onMainDataLoaded = (hasData) => {
        if (hasData) {
            showCalendarPage();
        } else {
            showLoginForm();
        }
    }
    dataManager.initialLoad()

    function showLoginForm(): void {
        firstLoginPage.show()
        calendarPageInstance.hide()
    }

    function showCalendarPage(): void {
        firstLoginPage.hide()
        calendarPageInstance.show()
    }

    async function submitFirstLogin(birth: string, age: number) {
        const result = dataManager.createAppData(birth, Number(age));
        if (result) showCalendarPage();
    }

    async function handleLogin(username: string, password: string): Promise<void> {
        await dataManager.login(username, password);  //this should automatically trigger onMainDataLoaded
    }

    window.addEventListener('resize', () => {
        calendarPageInstance.onResize();
    });
});

function renderPublicPage(dataManager: DataManager): boolean {
    const url = window.location.pathname
    const publicKey = dataManager.isPublicLink(url)
    if (!publicKey)  return false

    const publicPage = new PublicPage(dataManager);
    publicPage.setupHandlers();

    publicPage.loadPublicCalendar(publicKey).then((success) => {
        if (success) {
            publicPage.show();
            window.addEventListener('resize', () => {
                publicPage.onResize();
            });
        } else {
            document.body.innerHTML += '<div style="padding: 20px; text-align: center;"><h1>Error loading Calendar</h1></div>';
        }
    })

    return true;
}